export default __webpack_public_path__ + "static/media/casino-slot.b831b7db.png";